import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-12 min-w-min"
}

import { ref } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { useSaveBeforeLeaveConfirmationModal } from "shared/composables/toast";
import NonWorkingDays from "@/components/working_days/NonWorkingDays.vue";
import { useLoadCurrentProject } from "@/composables/project";


export default /*#__PURE__*/_defineComponent({
  __name: 'NonWorkingDaysModal',
  props: {
  open: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emits = __emit;
const { projectDurationSettings, isProjectDurationSettingsLoading } = useProjectDurationSettings();
const { project, isProjectLoading } = useLoadCurrentProject();
const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();
const nonWorkingDaysRef = ref<typeof NonWorkingDays | null>(null);
const handleCloseModal = () => {
  const hasChanges = nonWorkingDaysRef.value?.form?.meta.dirty;
  if (hasChanges) {
    showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
      if (confirmed) {
        emits("close");
      }
    });
  } else {
    emits("close");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: handleCloseModal,
    customCls: "h-fit max-w-[90vw] l:w-[120vh]"
  }, {
    content: _withCtx(() => [
      (_unref(isProjectDurationSettingsLoading) || _unref(isProjectLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (_unref(projectDurationSettings) && _unref(project))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(NonWorkingDays, {
                projectDurationSettings: _unref(projectDurationSettings),
                project: _unref(project),
                ref_key: "nonWorkingDaysRef",
                ref: nonWorkingDaysRef
              }, null, 8, ["projectDurationSettings", "project"])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})